import { z } from 'zod';
import { IsoDateTime, MutationReason } from './_common.js';
export const FeatureFlag = z.object({
    key: z.string(),
    description: z.string().nullable(),
    active: z.boolean(),
    variant: z.union([z.string(), z.number(), z.boolean(), z.null()]),
    rollout_percentage: z.number().int().min(0).max(100).nullable(),
    updated_at: IsoDateTime,
});
export const FeatureFlagListResponse = z.object({
    items: z.array(FeatureFlag),
    source: z.literal('posthog'),
});
export const FeatureFlagToggleRequest = z.object({
    active: z.boolean().optional(),
    variant: z.union([z.string(), z.number(), z.boolean(), z.null()]).optional(),
    rollout_percentage: z.number().int().min(0).max(100).nullable().optional(),
    reason: MutationReason,
});
export const FeatureFlagToggleResponse = FeatureFlag;
export const MaintenanceModeStatus = z.object({
    enabled: z.boolean(),
    reason: z.string().nullable(),
    message_en: z.string().nullable(),
    estimated_end_at: IsoDateTime.nullable(),
    enabled_by: z.string().nullable(),
    enabled_at: IsoDateTime.nullable(),
});
export const MaintenanceModeEnableRequest = z.object({
    message_en: z.string().min(5).max(280),
    estimated_end_at: IsoDateTime.nullable().default(null),
    reason: MutationReason,
});
export const MaintenanceModeEnableResponse = MaintenanceModeStatus;
export const MaintenanceModeDisableRequest = z.object({
    reason: MutationReason,
});
export const MaintenanceModeDisableResponse = MaintenanceModeStatus;
//# sourceMappingURL=switches.js.map